import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

/**
 * 來源區：客訂鎖定；用料由後端依 BOM 展開，前端不再自選。
 */
const ManufacturingMaterialsSourceSection = ({
  customerOrder,
  productFilterLabel = null,
}) => {
  const customerOrderDisplay = customerOrder?.customerOrderNo || '';

  return (
    <div className={cn('@container/form-area flex flex-col gap-4')}>
      <div className="form-block mb-0!">
        <h2 className="form-block__title">來源</h2>
        <p className="form-block__description">
          鎖定本張客戶訂單。系統依 BOM 展開用料需求，無需自行選擇 BOM。
        </p>
      </div>

      <div
        className={cn(
          'grid grid-cols-1 gap-4',
          '@lg/form-area:grid-cols-2',
        )}
      >
        <div className="min-w-0 space-y-1.5">
          <p className="text-xs font-medium text-gray-600">客訂單號</p>
          <p
            className={cn(
              'min-w-0 truncate rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm',
              !customerOrderDisplay && 'text-muted-foreground',
            )}
          >
            {customerOrderDisplay || '尚未選擇'}
          </p>
        </div>
        <div className="min-w-0 space-y-1.5">
          <p className="text-xs font-medium text-gray-600">製品篩選</p>
          <p
            className={cn(
              'min-w-0 truncate rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm',
              !productFilterLabel && 'text-muted-foreground',
            )}
          >
            {productFilterLabel || '整張訂單'}
          </p>
        </div>
      </div>
    </div>
  );
};

ManufacturingMaterialsSourceSection.propTypes = {
  customerOrder: PropTypes.shape({
    id: PropTypes.string,
    customerOrderNo: PropTypes.string,
  }),
  productFilterLabel: PropTypes.string,
};

export default ManufacturingMaterialsSourceSection;
